import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';
import clsx from 'clsx';

const useStyles = makeStyles(({ typography }) => ({
  icon: {
    width: typography.pxToRem(14),
    height: typography.pxToRem(14),
    fillOpacity: '0.87',
  },
}));

const Defer = ({ className, fill = '#E3AD1A', color = 'white' }) => {
  const styles = useStyles();

  return (
    <SvgIcon
      viewBox="0 0 13 13"
      className={clsx(styles.icon, className)}
      fill="none"
    >
      <rect width="13" height="13" fill={fill} />
      <g>
        <path
          d="M3.41248 10.5625V2.47559H5.90076C6.61169 2.47559 7.24672 2.63666 7.80585 2.9588C8.36867 3.27724 8.80745 3.73269 9.12219 4.32513C9.43693 4.91388 9.5943 5.58409 9.5943 6.33575V6.70789C9.5943 7.45955 9.43878 8.12791 9.12775 8.71295C8.82041 9.29799 8.38533 9.75159 7.82251 10.0737C7.25968 10.3959 6.62465 10.5588 5.91742 10.5625H3.41248ZM5.07874 3.82526V9.22394H5.88409C6.53579 9.22394 7.03381 9.01103 7.37817 8.58521C7.72253 8.15938 7.89842 7.55027 7.90582 6.75787V6.3302C7.90582 5.50818 7.73549 4.88611 7.39484 4.46399C7.05418 4.03817 6.55615 3.82526 5.90076 3.82526H5.07874Z"
          fill={color}
        />
      </g>
    </SvgIcon>
  );
};

export default memo(Defer);
